import type { Agent as AgentModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend Agent model to a frontend CatalogAgent type.
 * @param model - API Agent response from catalog
 * @returns CatalogAgent - UI-friendly Agent object
 */
export function extractAgent(model: AgentModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.agent_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    agentType: model.agent_type ?? '',
    enabled: model.enabled ?? false,
    status: model.status,
    version: model.version,
    modelProvider: model.model_provider,
    modelName: model.model_name,
    modelVersion: model.model_version,
    authMode: model.auth_mode,
    runtimeEndpoint: model.runtime_endpoint,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    updatedAt: model.updated_at ? new Date(model.updated_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgent = ReturnType<typeof extractAgent>;
